/** The business inputs a custom system has to account for. */
export const shapingInputs: string[] = [
  'Offers, customers, and buying decisions',
  'Sales, service, and fulfillment workflow',
  'Product, pricing, and account rules',
  'Existing systems and data',
  'Priorities, constraints, and future plans',
]

/** What WebsiteForge designs in response to those inputs. */
export const designedResponses: string[] = [
  'Site and content architecture',
  'Lead, quote, booking, and order paths',
  'Ecommerce and account logic',
  'Integrations and automation',
  'Reporting, support, and improvement plan',
]
